import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    wrapper: {
      width: "100%",
      display: "flex",
      gap: "0.5rem",
      flexWrap: "wrap",
    },
    label: {
      fontWeight: 700,
    },
  },
  { name: "SwatchesList" },
);

export { useStyles };
